import { ThunkDispatch } from "core-integration/src/store";
import { getActiveOrProposedTeamChipName } from "core-integration/src/store/chips/reducers";
import { chipActivationHandle } from "core-integration/src/store/chips/thunks";
import { IPotentialChip } from "core-integration/src/store/chips/types";
import { Button } from "plos/src/components/buttons/Button";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useTrackingContext } from "../../../contexts/TrackingContext";
import { getChipName } from "../../../utils/chips";

interface ChipActionProps {
  chip: IPotentialChip;
  handleClose: () => void;
}

const ChipAction = ({ chip, handleClose }: ChipActionProps) => {
  const { t } = useTranslation("chips");
  const { fireClickTrackEvent } = useTrackingContext();
  const dispatch = useDispatch<ThunkDispatch>();

  const activateChip = (name: string) => dispatch(chipActivationHandle(name));
  const deactivateChip = () => dispatch(chipActivationHandle(null));

  const chipInPlayName = useSelector(getActiveOrProposedTeamChipName);

  const { name: chipName, status_for_entry: statusForEntry } = chip;

  const chipDisplayName = getChipName(t, chipName);

  const playChip = () => {
    handleClose();
    activateChip(chipName);
    fireClickTrackEvent(
      {
        event_category: "fantasy team",
        event_component: "fantasy classic clicks",
        event_detail: chipDisplayName.toLowerCase(),
        event_type: "play chip",
      },
      "fantasy pick team",
    );
  };

  const cancelChip = () => {
    handleClose();
    deactivateChip();
  };

  switch (statusForEntry) {
    case "available":
      return (
        <Button appearance="success" size="small" fullWidth onPress={playChip}>
          {t("action.play", "Play {{chip}}", { chip: chipDisplayName })}
        </Button>
      );
    case "unavailable":
      return null;
    case "proposed":
    case "active":
      return (
        <Button appearance="error" size="small" fullWidth onPress={cancelChip}>
          {t("action.cancel", "Cancel {{chip}}", {
            chip: chipDisplayName,
          })}
        </Button>
      );
    case "cancelled":
      return (
        <Button
          appearance="success"
          size="small"
          fullWidth
          onPress={playChip}
          isDisabled={Boolean(chipInPlayName)}
        >
          {t("action.activate", "Activate {{chip}}", {
            chip: chipDisplayName,
          })}
        </Button>
      );
    default:
      return null;
  }
};

export default ChipAction;
